export default __webpack_public_path__ + "static/media/ic_order_details.f22c5ab3.svg";